import { mount } from 'svelte'
import ProfilePhotoForm from '@/components/users/ProfilePhotoForm.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('profile-photo-form-app')
  if (el) {
    mount(
      ProfilePhotoForm,
      {
        target: el,
        props: {
          user: el.dataset.user
        },
      })
  }
})
